/**
 * Analytics module exports
 */

export { ANALYTICS_EVENTS } from "./events";
export type { TrackEventFn } from "./events";

// Core hook
export { useAnalytics, usePostHog } from "./useAnalytics";

// Customer.io is now integrated into useAnalytics via AnalyticsManager

// Legacy PostHog React provider (wraps app)
export { PostHogProvider } from "./PostHogProvider";

// Domain-specific analytics hooks
export { useOnboardingAnalytics } from "./useOnboardingAnalytics";
export { useCreatorAnalytics } from "./useCreatorAnalytics";
export { useAudienceAnalytics } from "./useAudienceAnalytics";
export {
  AudienceAnalyticsProvider,
  useAudienceAnalyticsContext,
} from "./AudienceAnalyticsContext";

// PULSE retrieval variant store
export {
  getLastSeenPulseVariant,
  setLastSeenPulseVariant,
} from "./pulseVariant";

// Helpers and utilities
export * from "./helpers";
export * from "./firstTimeTracker";
export * from "./onboardingEventContracts";
export * from "./validateOnboardingEvents";
export * from "./posthog.constants";
export * from "./posthogFeatureFlags";
export * from "./metaPixel";
export * from "./metaPixel.constants";
export * from "./metaPixel.types";
